import React from "react";
import DropDown from "../elements/dropDown";
import "./poslovniProcesiOwnerItem.css";

export default function PoslovniProcesiOwnerItem({
  title,
  type,
  employees,
  preparedValue,
  controlledValue,
  approvedValue,
  onChangePrepared = () => {},
  onChangeControlled = () => {},
  onChangeApproved = () => {},
  disabled,
}) {
  const renderCell = (value, onChange) => {
    if (type === "static") {
      return (
        <li
          className="poslovni-procesi-table-item owner-item-disabled"
          style={{ width: "25%" }}
        ></li>
      );
    }

    if (type === "employee") {
      // prikaz samo kada ime postoji; prazna/nepotpuna vrednost ne sme dati "undefined undefined"
      const fullName = value
        ? `${value.first_name || ""} ${value.last_name || ""}`.trim()
        : "";
      const selectedName = fullName
        ? `${fullName}${
            value.designation_name ? " - " + value.designation_name : ""
          }`
        : "";
      return (
        <li
          className="poslovni-procesi-table-item"
          style={{ width: "25%", padding: "2px" }}
        >
          <DropDown
            list={employees || []}
            onChange={onChange}
            isMulti={false}
            selectedValue={selectedName}
            disabled={disabled}
            fontSize={12}
            paddingLeft={0}
          />
        </li>
      );
    }

    if (type === "date") {
      return (
        <li
          className="poslovni-procesi-table-item"
          style={{ width: "25%", padding: "2px" }}
        >
          <input
            type="date"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            style={{
              width: "100%",
              border: "none",
              outline: "none",
              color: "var(--mainColor)",
              fontSize: "12px",
              backgroundColor: "transparent",
            }}
          />
        </li>
      );
    }

    return (
      <li
        className="poslovni-procesi-table-item owner-item-disabled"
        style={{ width: "25%" }}
      ></li>
    );
  };

  return (
    <ul className="poslovni-procesi-table-list">
      <li
        className="poslovni-procesi-table-item owner-item-title"
        style={{ width: "25%" }}
      >
        {title}
      </li>
      {renderCell(preparedValue, onChangePrepared)}
      {renderCell(controlledValue, onChangeControlled)}
      {renderCell(approvedValue, onChangeApproved)}
    </ul>
  );
}
